import { useMutation, useQueryClient } from '@tanstack/react-query';
import driverAllocationAPI from '../api/driverAllocationAPI';
import { toast } from 'react-toastify';
import { showOrReplaceToast } from '../utils/utility';
import { CUSTOM_TOAST_ID } from '../constants/constant';

interface IDriverAllocation {
  bookingProductTripPickupId: number;
  operationStaffId: number;
  paxNo: number;
  bookingId: number;
  busAllocationId?: number;
  oldOperationStaffId?: number;
}

// Define the expected response from the API
interface AllocationResponse {
  success: boolean;
  message: string;
  data: any;
}

export const useSaveDriverAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation<AllocationResponse, Error, IDriverAllocation[]>({
    mutationFn: async (payload: any) => {
      try {
        const response =
          await driverAllocationAPI.addDriverPickupAllocation(payload);
        return response.data;
      } catch (error: any) {
        throw new Error(
          error.response?.data?.message ||
            error.message ||
            'Unknown error occurred',
        );
      }
    },
    onSuccess: (data: any) => {
      if (data) {
        // Invalidate the relevant queries to trigger a refetch data
        queryClient.invalidateQueries({
          queryKey: ['pickupAllocationDetails'],
        });
        toast.success(
          data.message || 'Driver Allocation details saved successfully',
        );
      } else {
        showOrReplaceToast(
          CUSTOM_TOAST_ID.flight,
          data.message || 'Failed to save driver allocation.',
          'error',
        );
      }
    },
    onError: (error: Error) => {
      console.error('Error saving driver allocation:', error.message);
      showOrReplaceToast(
        CUSTOM_TOAST_ID.flight,
        error.message || 'Failed to save driver allocation. Please try again.',
        'error',
      );
    },
  });
};
